module.exports = __webpack_public_path__ + "img/x8.500ac24b.jpg";